import type { RouteObject } from 'react-router';

import { SettingsServicePage } from './SettingsService';

/**
 * `/settings/:service` — one service's configuration table.
 *
 * **A path segment rather than a query parameter**, because the develop edge
 * drops the query string: `?service=auth` would survive a click and die on the
 * first reload or pasted link, which is the one case a deep link exists for.
 *
 * The segment is validated in the component, not by the router: an unknown or
 * unheld service renders a named refusal with the way back, where a router-level
 * fall-through would take the address the operator typed away from them before
 * they read what was wrong with it.
 */
export const settingsServiceRoute: RouteObject = {
  path: ':service',
  element: <SettingsServicePage />,
};
